/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.credit.memos.rpc.CreditMemosWithAssociatedObjectsService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './CreditMemosWithAssociatedObjectsService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.credit.memos.rpc.CreditMemosWithAssociatedObjectsService#create
 */
export const CREATE_MUTATION_FIELD_NAME = 'com_hubspot_credit_memos_rpc_CreditMemosWithAssociatedObjectsService_create';
export const CREATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_MUTATION_FIELD_NAME,
  args: ['associatedObjects', 'objectId', 'objectTypeId', 'properties'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.createRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.credit.memos.rpc.CreditMemosWithAssociatedObjectsService#createExpectedDraft
 */
export const CREATE_EXPECTED_DRAFT_MUTATION_FIELD_NAME = 'com_hubspot_credit_memos_rpc_CreditMemosWithAssociatedObjectsService_createExpectedDraft';
export const CREATE_EXPECTED_DRAFT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_EXPECTED_DRAFT_MUTATION_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.createExpectedDraftRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.credit.memos.rpc.CreditMemosWithAssociatedObjectsService#createExpectedDraftWithCreateOrUpdateRequest
 */
export const CREATE_EXPECTED_DRAFT_WITH_CREATE_OR_UPDATE_REQUEST_MUTATION_FIELD_NAME = 'com_hubspot_credit_memos_rpc_CreditMemosWithAssociatedObjectsService_createExpectedDraftWithCreateOrUpdateRequest';
export const CREATE_EXPECTED_DRAFT_WITH_CREATE_OR_UPDATE_REQUEST_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_EXPECTED_DRAFT_WITH_CREATE_OR_UPDATE_REQUEST_MUTATION_FIELD_NAME,
  args: ['associatedObjects', 'objectId', 'objectTypeId', 'properties'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.createExpectedDraftWithCreateOrUpdateRequestRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.credit.memos.rpc.CreditMemosWithAssociatedObjectsService#update
 */
export const UPDATE_MUTATION_FIELD_NAME = 'com_hubspot_credit_memos_rpc_CreditMemosWithAssociatedObjectsService_update';
export const UPDATE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_MUTATION_FIELD_NAME,
  args: ['associatedObjects', 'objectId', 'objectTypeId', 'properties'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.updateRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.credit.memos.rpc.CreditMemosWithAssociatedObjectsService#voids
 */
export const VOIDS_MUTATION_FIELD_NAME = 'com_hubspot_credit_memos_rpc_CreditMemosWithAssociatedObjectsService_voids';
export const VOIDS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: VOIDS_MUTATION_FIELD_NAME,
  args: ['objectId', 'objectTypeId', 'properties'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.voidsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.credit.memos.rpc.CreditMemosWithAssociatedObjectsService#getCreditMemoWithAssociatedObjects
 */
export const GET_CREDIT_MEMO_WITH_ASSOCIATED_OBJECTS_QUERY_FIELD_NAME = 'com_hubspot_credit_memos_rpc_CreditMemosWithAssociatedObjectsService_getCreditMemoWithAssociatedObjects';
export const GET_CREDIT_MEMO_WITH_ASSOCIATED_OBJECTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CREDIT_MEMO_WITH_ASSOCIATED_OBJECTS_QUERY_FIELD_NAME,
  args: ['creditMemoId'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getCreditMemoWithAssociatedObjectsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});